export var snakeToCamel = function (str) { return str.replace(/(_\w)/g, function (k) { return k[1].toUpperCase(); }); };
//# sourceMappingURL=index.js.map